import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWardrobe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconWardrobe"><Path fillRule="evenodd" clipRule="evenodd" d="M4 20V2H11V20H8V22H6V20H4ZM9 9H7V13H9V9Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18 20H20V2H13V20H16V22H18V20ZM17 9V13H15V9H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWardrobe;
